<script>
  import tipoUsuario from '~js/tipo-usuario';
  import webPessoaServico from '~modulos/web-pessoa/servico';
  import Carregando from '~componentes/Carregando.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosContatos from './compartilhado/FormDadosContatos.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import Socios from './compartilhado/FormSocios.vue';
  import Certidoes from './compartilhado/FormCertidoes.vue';
  import Atividades from './compartilhado/FormAtividades.vue';
  import DueDiligence from './compartilhado/FormDueDiligence.vue';
  
  export default {
    components: { Carregando, DadosCadastrais, DadosContatos, DadosBancarios, Socios, Certidoes, Atividades, DueDiligence, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
        tipoUsuario: tipoUsuario,
        senhaCriada: this.$storage.senhaCriada() || '',
        carregando: true,
        arquivos: [],
        arquivosCertidoes: [],
        habilitarDUEDiligence: false,
        abasPreenchidas: '',
        fornecedor: {
          nomePessoaFisicaJuridica: '',
          nomeFantasia: '',
          endereco: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: '',
          cpfCnpj: '',
          identidadeInscEstadual: '',
          carteiraTrabalhoInscMunicipal: '',
          telefone1: '',
          telefone2: '',
          fax: '',
          contato: '',
          cargoFinanceiro: '',
          telContatoFinanceiro: '',
          email: '',
          contatoCompras: '',
          cargoCompras: '',
          telContatoCompras: '',
          emailCompras: '',
          emailPesquisa: '',
          dataAlteracaoAcessoWeb: '',
          tipoPessoaFisicaJuridica: '',
          pagamentoBoleto: false,
          webDadosBancarios: [],
          webSocios: [],
          webCertidoes: [],
          webAtividades: [],
          webFormRespostasFornecedor: [],
          webFormRespostasParticipacaoAcionaria: [],
          webFormRespostasRelacaoContratual: [],
          webFormRespostasEmpresaReferencia: [],
          webFormRespostasRelacaoFundacao: [],
        },
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Alterar cadastro WEB';

      this.$root.botaoAcaoMostrar = false;
      
      this.carregar();

      this.habilitarDUEDiligence = this.configuracao.habilitarDUEDiligenceWeb;
    },
    methods: {
      mostrarConfirmacaoAlteracaoFornecedor() {
        if (!this.configuracao.alteracaoFornecedorConfirmacao) return;

        this.$swal({
          title: 'Alteração de Informações',
          html: this.configuracao.alteracaoFornecedorConfirmacao.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      validarDadosNaoEnviados(){
        if(!this.$refs.dadosBancarios.validarDadosNaoEnviados()){
          this.abasPreenchidas += "- Dados bancários<br/>";
        }

        if(!this.$refs.socios.validarDadosNaoEnviados()){
          this.abasPreenchidas += "- Sócios<br/>"; 
        }
        
        if(!this.$refs.certidoes.validarDadosNaoEnviados()){
          this.abasPreenchidas += "- Certidões<br/>";
        }
        
        if(!this.$refs.atividades.validarDadosNaoEnviados()){
          this.abasPreenchidas += "- Atividades<br/>";
        }

        if(this.habilitarDUEDiligence && !this.$refs.dueDiligence.validarDadosNaoEnviados()){
          this.abasPreenchidas += "- DUE DILIGENCE<br/>";
        }
        
        if(this.abasPreenchidas != ''){
          $('#salvar').button('reset');
          return false;
        }
        return true;
      },
      aviso() {
        if (!this.validarDadosNaoEnviados()) {
          this.$swal({
            title: '',
            html: "Há dados preenchidos e não enviados na(s) aba(s):<br/>" + this.abasPreenchidas,
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Salvar mesmo assim',
            cancelButtonText: 'Voltar',
            reverseButtons: true,
          })
            .then(() => {
              this.salvar();
            }).catch(() => {});
        } else {
          this.salvar();
        }
        this.abasPreenchidas = '';
      },
      salvar() {   
        if (this.validarAbas()) {
          $('#salvar').button('loading');

          if ([this.tipoUsuario.FornecedorWeb, this.tipoUsuario.FornecedorWebNovo].includes(this.usuario.tipoUsuario)) {
            this.$refs.dadosCadastrais.validar(true)
              .then(this.$refs.dadosContatos.validar)
              .then((valido) => {
                if (!valido) throw new Error("validacao com erro");
                return this.habilitarDUEDiligence
                  ? this.$refs.dueDiligence.validar(valido)
                  : true;
              })
              .then(this.enviar)
              .then(dados => {

                $('#salvar').button('reset');

                toastr.success(`Dados alterados com sucesso.`);

                if ('fornecedor' in dados) {
                  this.fornecedor = dados.fornecedor;
                  this.usuario = dados.usuario;
                  this.senhaCriada = dados.senhaCriada;

                  this.$storage.usuario(dados.usuario);
                  this.$storage.senhaCriada(dados.senhaCriada);
                } else {
                  this.fornecedor = dados;
                }

                this.$refs.listaArquivos.deletados = [];
                this.$refs.adicionarArquivos.limparArquivos();

                this.carregar();

              })
              .catch(erro => {

                $('#salvar').button('reset');

                this.$mensagemErro(erro);
              });      
          } else {
            this.$mensagemErro('Tipo de usuário está incorreto!');
          }

          this.mostrarConfirmacaoAlteracaoFornecedor();
        }
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        return (this.usuario.tipoUsuario === this.tipoUsuario.FornecedorWeb)
          ? this.alterar() : this.cadastrar();   
      },
      cadastrar() {
        this.$set(this.fornecedor, 'arquivosDeletados', this.$refs.listaArquivos.deletados)
        const arquivos = this.$refs.adicionarArquivos.arquivos;
        const arquivosCertidao = this.$refs.certidoes.arquivosCertidoes;

        return webPessoaServico.cadastrarFornecedor(this.fornecedor, arquivos, arquivosCertidao);
      },
      alterar() {
        this.$set(this.fornecedor, 'arquivosDeletados', this.$refs.listaArquivos.deletados)

        const arquivos = this.$refs.adicionarArquivos.arquivos;
        const arquivosCertidoes = this.$refs.certidoes.arquivosCertidoes;

        return webPessoaServico.alterarFornecedor(this.fornecedor, arquivos, arquivosCertidoes);
      },
      download(arquivo) {
        webPessoaServico
          .download(this.fornecedor.idPessoaFisicaJuridica, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },

      downloadCertidao(idCertidaoPessoa, arquivoCertidao) {
        webPessoaServico
          .downloadCertidao(idCertidaoPessoa, arquivoCertidao)
          .then(arquivo => {
            arquivo.download();
          });
      },

      carregar() {
        this.carregando = true;


        if (this.usuario.tipoUsuario === this.tipoUsuario.FornecedorWeb) {
          return webPessoaServico
            .fornecedor()
            .then(dados => {

              this.fornecedor = dados;
            })
            .then(() => webPessoaServico.arquivos(this.fornecedor.idPessoaFisicaJuridica))
            .then(arquivos => {
              this.arquivos = arquivos;
            })
            .then(() => {
              this.carregando = false;
            });
        } else {
          this.fornecedor.cpfCnpj = this.usuario.documento;
          this.fornecedor.tipoPessoaFisicaJuridica = this.usuario.documento.length <= 14 ? 1 : 2;

          for (let i = 1; i <= 9; i = i + 1) {
            this.fornecedor.webFormRespostasFornecedor.push({
              idFormPergunta: i,
              idWebFornecedor: '',
              resposta: null,
              dataCriacao: null,
            });
          }
          this.carregando = false;
          return;
        }
      },

      validarAbas() {
        /*
        var flag = true;
        var texto = "Adicione pelo menos uma informação na(s) seguinte(s) aba(s): <br>";

        if (this.fornecedor.webAtividades.length == 0) {       
          texto += "<br>- Atividades";
          flag = false;
        }
        if (this.fornecedor.webCertidoes.length == 0) {
          texto += "<br>- Certidões";
          flag = false;
        }
        if (this.fornecedor.webSocios.length == 0) {
          texto += "<br>- Socios";
          flag = false;
        }
 
        if (!flag) {
          this.$swal({
            title: 'Falta de Informações',
            html: texto,
            type: 'error',
            confirmButtonText: 'Ok, entendi!',
            allowOutsideClick: false,
            allowEscapeKey: false,
          });

          return false;
        }
*/
        return true;
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div v-if="senhaCriada.length > 0">
        <h2><b>Sua senha é: {{senhaCriada}}</b></h2>
        <p><b>Por favor anote-a para realizar futuros acessos!</b></p>
      </div>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab"
               href="#tab-dados-cadastrais">
              Dados cadastrais
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-dados-contatos">
              Contatos
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-dados-bancarios">
              Dados bancários
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-socios">
              Sócios
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-certidoes">
              Certidões
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-atividades">
              Atividades
            </a>
          </li>
          <li v-if="habilitarDUEDiligence">
            <a data-toggle="tab"
               href="#tab-due-diligence">
              DUE DILIGENCE
            </a>
          </li>
          <li v-if="configuracao.usarArquivosWebPessoas">
            <a data-toggle="tab"
               href="#tab-adicionar-arquivos">
              Adicionar arquivos
            </a>
          </li>
          <li v-if="configuracao.usarArquivosWebPessoas">
            <a data-toggle="tab"
               href="#tab-arquivos">
              Arquivos
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-dados-cadastrais" class="tab-pane active">
            <div class="panel-body">
              <dados-cadastrais ref="dadosCadastrais"
                                :fornecedor="fornecedor"
                                :carregando="carregando">
              </dados-cadastrais>
            </div>
          </div>

          <div id="tab-dados-contatos" class="tab-pane">
            <div class="panel-body">
              <dados-contatos ref="dadosContatos"
                              :fornecedor="fornecedor">
              </dados-contatos>
            </div>
          </div>

          <div id="tab-dados-bancarios" class="tab-pane">
            <div class="panel-body">
              <dados-bancarios ref="dadosBancarios"
                               :dadosBancarios="fornecedor.webDadosBancarios">
              </dados-bancarios>
            </div>
          </div>

          <div id="tab-socios" class="tab-pane">
            <div class="panel-body">
              <socios ref="socios"
                      :socios="fornecedor.webSocios">
              </socios>
            </div>
          </div>

          <div id="tab-certidoes" class="tab-pane">
            <div class="panel-body">
              <certidoes ref="certidoes"
                         :certidoes="fornecedor.webCertidoes"
                         @downloadCertidao="downloadCertidao"
                         :arquivosCertidoes="arquivosCertidoes">
              </certidoes>
            </div>
          </div>

          <div id="tab-atividades" class="tab-pane">
            <div class="panel-body">
              <atividades ref="atividades"
                          :atividades="fornecedor.webAtividades">
              </atividades>
            </div>
          </div>

          <div id="tab-due-diligence" class="tab-pane" v-if="habilitarDUEDiligence">
            <div class="panel-body">
              <due-diligence ref="dueDiligence"
                             :webFormRespostasFornecedor="fornecedor.webFormRespostasFornecedor"
                             :webFormRespostasParticipacaoAcionaria="fornecedor.webFormRespostasParticipacaoAcionaria"
                             :webFormRespostasRelacaoContratual="fornecedor.webFormRespostasRelacaoContratual"
                             :webFormRespostasEmpresaReferencia="fornecedor.webFormRespostasEmpresaReferencia"
                             :webFormRespostasRelacaoFundacao="fornecedor.webFormRespostasRelacaoFundacao"
                             :habilitarDUEDiligence="habilitarDUEDiligence">
              </due-diligence>
            </div>
          </div>

          <div id="tab-adicionar-arquivos" class="tab-pane">
            <div class="panel-body">
              <adicionar-arquivos ref="adicionarArquivos">
              </adicionar-arquivos>
            </div>
          </div>

          <div id="tab-arquivos" class="tab-pane">
            <div class="panel-body">
              <lista-de-arquivos :arquivos="arquivos"
                                 @download="download"
                                 ref="listaArquivos">
              </lista-de-arquivos>
            </div>
          </div>
        </div>

      </div>

      <div class="row" v-show="!carregando">
        <div class="col-xs-9">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'home' }"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="aviso"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
        <div class="col-xs-9">
          <span class="time-right" v-if="fornecedor.dataAlteracaoAcessoWeb">
            Última atualização realizada em {{fornecedor.dataAlteracaoAcessoWeb | formatarData }} às {{fornecedor.dataAlteracaoAcessoWeb | formatarHora }}
          </span>
        </div>
      </div>
      
    </form>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/Alterar.vue